var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showIfPro || !_vm.isPro && (_vm.isMaintenanceMode) && !_vm.$auth.user.membership.activeUntil)?_c('div',[_vm._t("default",null,null,{ click: _vm.click, isPro: _vm.isPro, isMob: _vm.isMob })],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }